import { useEffect } from "react";
import { subscribeToAuthBroadcasts } from "../services/authBroadcastService";

/**
 * Custom Hook to listen for cross-tab auth broadcasts.
 * Automatically handles registration, dependency changes, and cleanup.
 */
export const useAuthBroadcast = (handlers, deps) => {
  useEffect(() => {
    const unsubscribe = subscribeToAuthBroadcasts(handlers);
    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
